import { isPlainObject } from '../../../../helpers/common';

export function toChecklistDataMapper(data) {
    if(Array.isArray(data)) {
        if(data.every(p => typeof p == 'object')) {
            return Object.fromEntries(data.map(p => {
                let pKey = Object.values(p)[0];
                let pData = Object.assign({}, p);
                pData[pKey] = 1;

                return [ pKey, pData ];
            }));
        } else {
            return Object.fromEntries(data.map(p => [ p, 1 ]));
        }
    } else if(data && typeof data == 'object') {
        let ret = {};

        ret[Object.values(data)[0]] = 1;

        return ret;
    }

    return data;
}

export function fromChecklistDataMapper(data) {
    let dataArr = Object.values(data);

    if(isPlainObject(data)) {
        if(dataArr.every(p => typeof p == 'object')) {
            let result = [];

            Object.keys(data).forEach(key => {
                if(data[key][key] == 1) {
                    let item = Object.assign({}, data[key]);
                    delete item[key];
                    result.push(item);
                }
            });

            return result;
        } else {
            return Object.entries(data).filter(([key, val]) => val == 1).map(([key, val]) => { return key; });
        }
    }

    return data;
}